import { render, staticRenderFns } from "./WideCardsContainer.vue?vue&type=template&id=010f0e66&scoped=true"
import script from "./WideCardsContainer.vue?vue&type=script&lang=js"
export * from "./WideCardsContainer.vue?vue&type=script&lang=js"
import style0 from "./WideCardsContainer.vue?vue&type=style&index=0&id=010f0e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010f0e66",
  null
  
)

export default component.exports